import React from "react";
import { PublicMemorialCard } from "./PublicMemorialCard";
import { Memorial } from "@/hooks/use-memorials";

interface PublicMemorialsListProps {
  memorials: Memorial[];
  onView: (memorialId: string) => void;
}

export const PublicMemorialsList = ({ memorials, onView }: PublicMemorialsListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {memorials.map((memorial) => (
        <PublicMemorialCard
          key={memorial.id}
          memorial={memorial}
          onView={onView}
        />
      ))}
    </div>
  );
};